<template>
 <div>
  <router-view />
</div>
</template>

<script>

export default {
  name: 'hospitalManagement',
  components: {
  }
}
</script>
<style lang="less" scoped>
</style>
